/* eslint-disable camelcase */
import SidebarCart from "./SidebarCart";
import AjaxBlocking from "./AjaxBlocking";

export default class AddToCart {
    constructor() {
        this.isCartPage = document.querySelector("div.cart-page");
        this.isCartPage = !!this.isCartPage;
        this.sidebarCart = new SidebarCart();
    }

    init() {
        this.events();
    }

    events() {
        const closeAddToCartModal = document.querySelector(
            ".jsAddToCartModalClose"
        );

        if (closeAddToCartModal) {
            const modalContainer = document.querySelector(".jsAddToCartModal");
            closeAddToCartModal.addEventListener("click", (e) => {
                modalContainer.classList.add("is-hidden");
            });
        }

        document.querySelectorAll("body")[0].addEventListener("click", (e) => {
            if (e.target.classList.contains("js-add-to-cart")) {
                e.preventDefault();
                this.add_to_cart(e.target);
            } else if (e.target.closest(".js-add-to-cart")) {
                e.preventDefault();
                this.add_to_cart(e.target.closest(".js-add-to-cart"));
            }

            if (e.target.classList.contains("js-qov-add-to-cart")) {
                e.preventDefault();
                this.quickViewAddToCart(e.target);
            } else if (e.target.closest(".js-qov-add-to-cart")) {
                e.preventDefault();
                this.quickViewAddToCart(
                    e.target.closest(".js-qov-add-to-cart")
                );
            }

            if (e.target.classList.contains("js-sp-add-to-cart")) {
                e.preventDefault();
                this.singleProductAddToCart(e.target);
            } else if (e.target.closest(".js-sp-add-to-cart")) {
                e.preventDefault();
                this.singleProductAddToCart(
                    e.target.closest(".js-sp-add-to-cart")
                );
            }

            if (e.target.classList.contains(".js-cmp-add-to-cart")) {
                e.preventDefault();
                this.compareAddToCart(e.target);
            } else if (e.target.closest(".js-cmp-add-to-cart")) {
                e.preventDefault();
                this.compareAddToCart(
                    e.target.closest(".js-cmp-add-to-cart")
                );
            }
        });
    }

    // eslint-disable-next-line camelcase
    remove_events() {
        console.log([...this.add_to_cart_button]);
        [...this.add_to_cart_button].forEach((el) => {
            el.removeEventListener("click", null);
        });
    }

    compareAddToCart(element) {
        const compareModalContent = element.closest("#jsCompareModalContent");
        const compareModal = document.getElementById("jsCompareModal");
        const id = element.dataset.productId;
        const qty = 1;

        if (compareModalContent) {
            this.addToCartRequest(compareModalContent, id, qty);
            setTimeout(() => {
                compareModal.style.display = "none";
                document.body.classList.remove("is-fixed");
            }, 500);
        }
    }

    quickViewAddToCart(element) {
        const quickLookBox = element.closest("#jsQuickLookBox");
        const quickOverview = element.closest("#jsQuickLookOverview");
        const quickQtyAttributes = document.querySelector(
            ".qty-buttons"
        );
        const id = element.dataset.productId;
        let qty = 1;

        if (quickOverview) {
            if (!quickQtyAttributes) {
                qty = quickOverview.querySelector(".input-text.qty").value;
            } else {
                const qtyMultiplier =
                    quickOverview.querySelector(".js-active").dataset.qty;
                qty =
                    qtyMultiplier *
                    quickOverview.querySelector(".input-text.qty").value;
            }

            if (isNaN(qty) || qty === "") {
                qty = 1;
            }

            this.addToCartRequest(quickLookBox, id, qty);
        }
    }

    singleProductAddToCart(element) {
        const productWrapper = element.closest(".single-product-details");
        const productQtyAttributes = document.querySelector(
            ".single-product__attributes"
        );
        const id = element.value;
        const qtyWrapper = productWrapper.querySelector(".input-text.qty");
        let qty = 1;

        if (productWrapper) {
            if (!productQtyAttributes) {
                if (qtyWrapper) {
                    qty = productWrapper.querySelector(".input-text.qty").value;
                }
            } else {
                const qtyMultiplier =
                    productWrapper.querySelector(".js-active").dataset.qty;
                qty =
                    qtyMultiplier *
                    productWrapper.querySelector(".input-text.qty").value;
            }

            if (isNaN(qty) || qty === "") {
                qty = 1;
            }

            this.addToCartRequest(productWrapper, id, qty);
        }
    }

    // eslint-disable-next-line camelcase
    add_to_cart(element) {
        let qty = 1;
        const parent_el = Array.from(
            element.parentNode.children
        ).filter((child) => (child) => child.classList.contains("quantity"));

        if (parent_el[0].classList.contains("quantity")) {
            qty = parent_el[0].querySelector(".qty").value;
        }

        const id = element.dataset.productId;
        this.addToCartRequest(element, id, qty);
    }

    addToCartRequest(element, id, qty = 1) {
        const widthWindow = window.innerWidth
            || document.documentElement.clientWidth
            || document.body.clientWidth;

        this.blockForAjax(element);

        fetch(window.global.ajax_url + "?action=addProductToCart", {
            method: "POST", //* GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, *cors, same-origin
            cache: "no-cache", //* default, no-cache, reload, force-cache, only-if-cached
            credentials: "same-origin", // include, *same-origin, omit
            headers: {
                // "Content-Type": "application/json",
                "Content-Type": "application/x-www-form-urlencoded",
            },
            redirect: "follow", // manual, *follow, error
            referrerPolicy: "no-referrer", // no-referrer, *client
            body: new URLSearchParams({
                security: window.global.security,
                id: id,
                qty: qty,
                isCartPage: this.isCartPage,
            }),
        })
            .then((resp) => resp.json())
            .then((data) => {
                if (data.success === false) {
                    const noticeContainer = document.querySelector(
                        ".jsPageNoticeWrapper"
                    );
                    const noticesWrapper = document.getElementById(
                        "page__notices-wrapper"
                    );

                    noticesWrapper.innerHTML = data.data.wc_notices;

                    if (noticeContainer) {
                        noticeContainer.classList.remove("is-hidden");

                        window.setTimeout(() => {
                            noticeContainer.classList.add("is-hidden");
                        }, 10000);
                    }
                }
                
                if (data.success) {
                    if (data.data.cart_count) {
                        [
                            ...document.getElementsByClassName(
                                "header-top__cart--count"
                            ),
                        ].forEach((el) => {
                            el.innerHTML = data.data.cart_count;
                        });
                        [
                            ...document.getElementsByClassName(
                                "mini-cart__count"
                            ),
                        ].forEach((el) => {
                            el.innerHTML = data.data.cart_count;
                        });
                    }

                    // Update mini-cart
                    jQuery(document.body).trigger("wc_fragment_refresh");

                    !function(f,b,e,v,n,t,s)
                    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                    n.queue=[];t=b.createElement(e);t.async=!0;
                    t.src=v;s=b.getElementsByTagName(e)[0];
                    s.parentNode.insertBefore(t,s)}(window, document,'script',
                    'https://connect.facebook.net/en_US/fbevents.js');
                    fbq('init', '174863670915310');

                    fbq("track", "AddToCart", {
                        content_name: data.data.item_name,
                        content_ids: "['" + data.data.item_id + "']",
                        content_type: "product",
                        value: data.data.item_price,
                        currency: data.data.item_currency,
                    });

                    if (widthWindow < 1280) {
                        const modalContainer =
                            document.querySelector(".jsAddToCartModal");

                        if (modalContainer) {
                            this.modalAfterAddToCart(
                                modalContainer,
                                data.data.item_image,
                                data.data.item_name,
                                data.data.cart_count,
                                data.data.cart_total
                            );
                        }
                    } else {
                        const noticeContainer = document.querySelector(
                            ".jsPageNoticeWrapper"
                        );
                        const noticesWrapper = document.getElementById(
                            "page__notices-wrapper"
                        );

                        noticesWrapper.innerHTML = data.data.wc_notices;

                        if (noticeContainer) {
                            noticeContainer.classList.remove("is-hidden");

                            window.setTimeout(() => {
                                noticeContainer.classList.add("is-hidden");
                            }, 10000);
                        }
                    }
                }

                if (this.isCartPage) {
                    location.reload();
                }

                this.unblockForAjax(element);
            })
            .catch((err) => {
                console.log(err);
                this.unblockForAjax(element);
            });
    }

    modalAfterAddToCart(modalContainer, image, name, count, total) {
        const modalContainerImage = document.querySelector(
            ".jsAddToCartModalImage"
        );
        const modalContainerName = document.querySelector(
            ".jsAddToCartModalName"
        );
        const modalContainerCount = document.querySelector(
            ".jsAddToCartModalCount"
        );
        const modalContainerTotal = document.querySelector(
            ".jsAddToCartModalTotal"
        );

        modalContainerImage.innerHTML = image;
        modalContainerName.innerHTML = name;
        modalContainerCount.innerHTML = count;
        modalContainerTotal.innerHTML = total;

        modalContainer.classList.remove("is-hidden");
    }

    blockForAjax(element) {
        if (!element) return;

        const myBlock = new AjaxBlocking();
        myBlock.blockOnAjax(element);
    }

    unblockForAjax(element) {
        if (!element) return;

        const myBlock = new AjaxBlocking();
        myBlock.unblockOnAjax(element);
    }
}
